// src/components/ChargingStation/ChargerDetails.tsx
import React from "react";
import { View, Text, Image, StyleSheet } from "react-native";
import RateDisplay from "../ChargerRateDisplay";
import { ChargerAttributes } from "../../models/charger-model";

interface ChargerDetailsProps {
  renderCharger: ChargerAttributes;
}

const ChargerDetails: React.FC<ChargerDetailsProps> = ({ renderCharger }) => {
  return (
    <View style={styles.BgColor3} className="p-3 rounded-lg">
      <Text className="text-base font-semibold text-white">Charger</Text>
      <View className="flex flex-row gap-4 items-center py-2">
        <Image
          source={require("../../../assets/chargerType.png")}
          style={{ height: 40, width: 40 }}
          alt="ChargerType"
        />
        <View>
          <Text className="text-xs font-normal text-white">
            {`${renderCharger?.manufacturer_name}-${
              renderCharger?.charger_type
            } ${renderCharger?.plug_type ?? ""} Charger`}
          </Text>
          <View className="flex flex-row gap-2 items-center">
            <Text className="text-base font-semibold text-white">
              {renderCharger?.charging_capacity !== undefined
                ? `${((renderCharger.charging_capacity * 240)/1000).toFixed(1)}kW`
                : '-- kW'}
            </Text>
            <Text className="text-xs font-normal text-white">Max power</Text>
          </View>
        </View>
      </View>
      <RateDisplay renderCharger={renderCharger} />
    </View>
  );
};

const styles = StyleSheet.create({
  BgColor3: {
    backgroundColor: "#203D3C",
  },
});

export default ChargerDetails;
